.popover.attribute-filter.animated
  .popover-arrow
  .popover-content
    .attribute-filter__header
      h4 Nach #{opts.name} filtern
      a(href="#", role="button", data-hook="popover-close").popover-close: i.ion-close-round

    ul(data-hook="list").attribute-filter__list
